import { Box, Card, Typography, Alert, Divider, Stack } from "@mui/material";
import { IRegieSimulationResults } from "../../interface/regie";

const formatEuro = (value: number) => `${value.toLocaleString("fr-FR", { maximumFractionDigits: 2 })} €`;
const formatPercent = (value: number) => `${(value * 100).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} %`;

interface RegieResultsPanelProps {
  results: IRegieSimulationResults | null;
  tjmPropose: number;
}

export default function RegieResultsPanel({ results, tjmPropose }: RegieResultsPanelProps) {
  if (!results) {
    return (
      <Card sx={{ p: 3, borderRadius: "16px", border: "1px solid #e2e8f0" }}>
        <Typography variant="body2" color="text.secondary">Renseignez les paramètres pour voir l'aperçu du calcul.</Typography>
      </Card>
    );
  }

  const tjmSousMinimum = tjmPropose < results.tjmAAppliquer;

  return (
    <Card sx={{ p: 3, borderRadius: "16px", border: "1px solid #e2e8f0" }}>
      {results.indemnitesKmWarning && <Alert severity="warning" sx={{ mb: 2 }}>{results.indemnitesKmWarning}</Alert>}
      {tjmSousMinimum && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Le TJM proposé ({formatEuro(tjmPropose)}) est inférieur au TJM à appliquer ({formatEuro(results.tjmAAppliquer)}) : la marge cible ne sera pas atteinte.
        </Alert>
      )}

      <Stack spacing={1}>
        <Row label="Jours travaillés" value={String(results.joursTravailles)} />
        <Row label="Jours facturables" value={String(results.joursFacturables)} />
        <Row label="Brut annuel" value={formatEuro(results.brutAnnuel)} />
        <Row label="Super brut + frais annuels" value={formatEuro(results.superBrutEtFraisAnnuels)} />
        <Row label="Mutuelle patronale (annuel, informatif)" value={formatEuro(results.mutuellePatronaleAnnuelle)} />
        <Divider />
        <Row label="CA annuel mini à générer" value={formatEuro(results.caAnnuelMini)} />
        <Row label="TJM à appliquer" value={formatEuro(results.tjmAAppliquer)} bold />
        <Divider />
        <Row label="CA annuel cible (TJM proposé)" value={formatEuro(results.caAnnuelCible)} />
        <Row label="Marge absolue annuelle" value={formatEuro(results.margeAbsolueAnnuelle)} />
        <Row label="Marge relative annuelle" value={formatPercent(results.margeRelativeAnnuelle)} bold />
      </Stack>
    </Card>
  );
}

const Row = ({ label, value, bold }: { label: string; value: string; bold?: boolean }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between" }}>
    <Typography variant="body2" color="text.secondary">{label}</Typography>
    <Typography variant="body2" sx={{ fontWeight: bold ? 700 : 400 }}>{value}</Typography>
  </Box>
);
